import { email } from '@vuelidate/validators';

export default {
    email
};